<template>
  <Card>
    <template v-slot:title> Dados da venda </template>
    <template v-slot:content>
      <ItemMetadata :item="formData"></ItemMetadata>
      <AppForm
        ref="form"
        :rules="rules"
        :values="formData"
        v-slot:default="{ formErrors }"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6 p-lg-4">
            <AppFormItem
              :error="formErrors.responsibleName"
              label="Responsável"
            >
              <InputText
                v-model="responsibleName"
                :disabled="!!this.$route.params.id"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-4">
            <AppFormItem label="Nota fiscal">
              <InputText v-model="invoice" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-4">
            <AppFormItem label="Data da venda">
              <Calendar
                v-model="date"
                dateFormat="dd/mm/yy"
                showIcon
                :monthNavigator="true"
                :yearNavigator="true"
                :yearRange="dateRange"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12">
            <AppFormItem label="Observações">
              <Textarea v-model="observation" rows="2" />
            </AppFormItem>
          </div>
          <div class="p-col-12 p-mb-3">
            <BovineTypeSummary :bovines="bovines"></BovineTypeSummary>
          </div>
          <div class="p-col-12 p-lg-6">
            <p class="p-text-bold">
              Valor médio por bovino: {{ $toCurrency(averageValue) }}
              <br />
              Valor médio por KG: {{ $toCurrency(averageKgValue) }}
              <br />
              Valor total da venda: {{ $toCurrency(totalValue) }}
            </p>
          </div>
          <div class="p-col-12 p-lg-6">
            <p class="p-text-bold">
              Peso médio: {{ $toCurrency(averageWeight, true) }} Kg
              <br />
              Peso total: {{ $toCurrency(totalWeight, true) }} Kg
            </p>
          </div>
        </div>
      </AppForm>
    </template>
    <template v-slot:footer>
      <div class="p-grid p-jc-between p-mt-2">
        <div style="padding-left: 8px">
          <SplitButton
            v-if="$route.params.id"
            label="Ações"
            :model="items"
          ></SplitButton>
          <Button
            label="Refazer Venda"
            class="p-button-outlined p-ml-2"
            @click="this.$emit('redo')"
          />
        </div>
        <div style="padding-right: 8px">
          <Button
            label="Voltar"
            class="p-button-outlined p-mr-2"
            @click="$emit('prev-page')"
          />
          <AppButton
            label="Salvar"
            @click="$emit('save')"
            :loading="loadingSave"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import BovineTypeSummary from '../../components/BovineTypeSummary';
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import ItemMetadata from '../../components/ItemMetadata.vue';

export default {
  name: 'SaleReviewForm',
  components: {
    BovineTypeSummary,
    ItemMetadata,
  },
  computed: {
    ...mapFields('sale', [
      'formData',
      'formData.responsibleName',
      'formData.invoice',
      'formData.date',
      'formData.observation',
      'loadingSave',
    ]),
    ...mapFields('app', ['user']),
    ...mapGetters('sale', [
      'totalValue',
      'totalWeight',
      'averageWeight',
      'averageValue',
      'averageKgValue',
    ]),
    bovines() {
      return this.formData.bovines.map((saleBovine) => saleBovine.bovine);
    },
    items() {
      const data = [];

      if (this.$ability.can('delete', 'Sale')) {
        data.push({
          label: 'Excluir venda',
          command: () => this.$emit('delete'),
        });
      }

      if (this.formData.statusId === 3) {
        data.unshift({
          label: 'Reativar venda',
          command: () => this.$emit('activate'),
        });
      } else {
        data.unshift({
          label: 'Cancelar venda',
          command: () => this.$emit('cancel'),
        });
      }
      return data;
    },
  },
  data() {
    return {
      dateRange: `${this.$dayjs()
        .subtract(10, 'y')
        .format('YYYY')}:${this.$dayjs().add(10, 'y').format('YYYY')}`,
      rules: {
        responsibleName: [
          { required: true, message: 'Informe o nome do responsável.' },
        ],
      },
    };
  },
  created() {
    if (!this.responsibleName) {
      this.responsibleName = this.user.name || this.user.username;
    }
    if (!this.date) {
      this.date = new Date();
    }
  },
};
</script>

<style lang="css" scoped>
div >>> .p-card-footer {
  padding: 0;
}

div >>> .p-splitbutton-defaultbutton:hover {
  background: rgba(33, 150, 243, 0.04);
  color: #2196f3;
}
div >>> .p-splitbutton-menubutton:hover {
  background: rgba(33, 150, 243, 0.04);
  color: #2196f3;
}

div >>> .p-splitbutton-defaultbutton {
  margin-right: 0 !important;
  background-color: transparent;
  color: #2196f3;
  border: 1px solid;
  border-right: none;
}

div >>> .p-splitbutton-menubutton {
  margin-right: 0 !important;
  width: 50px !important;
  background-color: transparent;
  color: #2196f3;
  border: 1px solid;
  border-left: none;
}
</style>